<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto" label-position="top">
                        <div class="grid gap-4" :class="[
                                loginUserRole === ROLES.SYSTEM ? 'md:grid-cols-7' : (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead ? 'md:grid-cols-6' : 'md:grid-cols-5'),
                            ]">
                            <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                <OrganizationSelect v-model="searchForm.organization_id" :is-search="true"
                                    placeholder="組織を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin"
                                v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" label="部門">
                                <DepartmentSelect :organization-id="searchForm.organization_id" :is-search="true"
                                    v-model="searchForm.department_id" placeholder="部門を選択" @organization-id-change="searchForm.organization_id = $event" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="カテゴリ">
                                <CategorySelect :organization-id="searchForm.organization_id" :is-search="true"
                                    v-model="searchForm.category_id" placeholder="カテゴリを選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="アイテム名">
                                <AutoCompleteInput v-model="searchForm.material_name" placeholder="アイテム名を入力"
                                    storage-key="material-name-history" :max-history-items="15"
                                    ref="materialNameInput" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="ステータス">
                                <el-select v-model="searchForm.status" placeholder="ステータスを選択">
                                    <el-option label="すべて" :value="ALL" />
                                    <el-option label="未対応" :value="1" />
                                    <el-option label="補充依頼中" :value="2" />
                                    <el-option label="発注済み" :value="3" />
                                    <el-option label="廃棄予定" :value="4" />
                                    <el-option label="対応完了" :value="5" />
                                </el-select>
                            </el-form-item>

                            <el-form-item class="no-margin" label="アラート">
                                <el-select v-model="checkResult" multiple placeholder="アラートを選択してください"
                                    collapse-tags
                                    collapse-tags-tooltip>
                                    <el-option v-for="item in checkResults" :key="item.value"
                                        :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="hidden md:block w-24" type="primary"
                                    @click="handleSearchButton">検索</el-button>
                            </div>

                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb"
                    :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto" label-position="top">
                            <div class="grid gap-4">
                                <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                    <OrganizationSelect v-model="searchForm.organization_id" :is-search="true"
                                        placeholder="組織を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin"
                                    v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" label="部門">
                                    <DepartmentSelect :organization-id="searchForm.organization_id" :is-search="true"
                                        v-model="searchForm.department_id" placeholder="部門を選択" @organization-id-change="searchForm.organization_id = $event" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="カテゴリ">
                                    <CategorySelect :organization-id="searchForm.organization_id" :is-search="true"
                                        v-model="searchForm.category_id" placeholder="カテゴリを選択" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="アイテム名">
                                    <AutoCompleteInput v-model="searchForm.material_name" placeholder="アイテム名を入力"
                                        storage-key="material-name-history" :max-history-items="15"
                                        ref="materialNameInput" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="ステータス">
                                    <el-select v-model="searchForm.status" placeholder="ステータスを選択">
                                        <el-option label="すべて" :value="ALL" />
                                        <el-option label="未対応" :value="1" />
                                        <el-option label="補充依頼中" :value="2" />
                                        <el-option label="発注済み" :value="3" />
                                        <el-option label="廃棄予定" :value="4" />
                                        <el-option label="対応完了" :value="5" />
                                    </el-select>
                                </el-form-item>

                                <div class="flex">
                                    <el-form-item class="no-margin flex-grow" label="アラート">
                                        <el-select v-model="checkResult" multiple placeholder="アラートを選択してください"
                                            collapse-tags
                                            collapse-tags-tooltip>
                                            <el-option v-for="item in checkResults" :key="item.value"
                                                :label="item.label" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <div class="flex justify-end mt-7">
                                        <el-button class="md:hidden ml-3" type="primary" @click="handleSearchButton" circle>
                                            <el-icon>
                                                <span class="material-symbols-outlined">manage_search</span>
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center">
                    <el-button class="custom-alert-icon-btn md:hidden" type="primary" @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>
                </div>
            </div>
        </el-header>

        <el-mian style="padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
                <div class="custom-alert-title flex flex-col">
                    <span>アラート（在庫数　品名　有効期間）</span>
                    <span class="ml-auto">アイテム数: {{ mTotalRecords }}</span>
                </div>

                <div style="overflow-y: auto; height: calc(100vh - 227px)">
                    <el-card v-for="item in mTableData" :key="item.id"
                        style="border: 1px solid #d1d5db; border-radius: 0px"
                        :style="{ backgroundColor: new Date(item.expiration_date) < new Date() ? '#f3f3c1' : '' }"
                        @click="handleEditButton(item, true)">
                        <div class="relative">
                            <span
                                class="material-symbols-outlined cursor-pointer absolute top-0 right-1 text-gray-600 z-10"
                                style="font-size: 24px;" @click.stop.prevent="openNotificationDialog(item)">
                                mail
                            </span>
                            <el-row align="middle" class="relative z-0">
                                <el-col :span="8" align="middle">
                                    <span class="text-5xl" :class="{ 'text-red-500': item.check_result6 === 2 }">
                                        {{ item.quantity }}
                                    </span>
                                </el-col>

                                <el-col :span="15" class="ml-2">
                                    <div class="pr-7">{{ item.material_name }}</div>
                                    <el-row align="middle">
                                        <div class="min-w-[122px]">
                                            <span class="text-xl font-bold"
                                                :class="{ 'text-red-500': new Date(item.expiration_date) < new Date() }">
                                                {{ moment(item.expiration_date).format('YYYY-MM-DD') }}
                                            </span>
                                            <div>{{ getAlert(item).join('・') }}</div>
                                        </div>
                                        <div class="flex-grow ml-2 text-center" @click.stop="editStatus(item)">
                                            <div v-if="item.status === 1"
                                                class="bg-red-400 border-2 border-gray-900 rounded-md">未対応</div>
                                            <div v-if="item.status === 2"
                                                class="bg-green-400 border-2 border-gray-900 rounded-md">補充依頼中</div>
                                            <div v-if="item.status === 3"
                                                class="bg-purple-400 border-2 border-gray-900 rounded-md">発注済み</div>
                                            <div v-if="item.status === 4"
                                                class="bg-yellow-400 border-2 border-gray-900 rounded-md">廃棄予定</div>
                                            <div v-if="item.status === 5"
                                                class="bg-sky-400 border-2 border-gray-900 rounded-md">対応完了</div>
                                        </div>
                                    </el-row>

                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="alert-table hidden md:block w-full">
                <el-table :data="mTableData" height="calc(100vh - 260px)"
                    v-loading="loading" :row-class-name="tableRowClassName">
                    <el-table-column label="　" width="80" align="center">
                        <template #default="scope">
                            <el-button class="w-12" type="primary" style="background-color: #c2dbf0;" text bg
                                @click="handleEditButton(scope.row)">
                                <span>詳細</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="loginUserRole === ROLES.SYSTEM" prop="organization_name" label="組織"
                        width="200" />
                    <el-table-column prop="department_name" label="部門" width="160" />
                    <el-table-column prop="category_name" label="カテゴリ" width="160" />
                    <el-table-column prop="material_name" label="アイテム名" min-width="400">
                        <template #default="scope">
                            {{ scope.row.material_name }}<br />
                            <span v-if="scope.row.jancode" class="text-sm text-gray-500">
                                （{{ scope.row.jancode }}）
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_name" label="担当者" width="160" />
                    <el-table-column prop="storage_date" label="保管日" width="100" align="center">
                        <template #default="{ row }">
                            {{ moment(row.storage_date).format('YYYY-MM-DD') }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="expiration_date" label="有効期限" width="100" align="center">
                        <template #default="{ row }">
                            <span :class="{ 'text-red-500': new Date(row.expiration_date) < new Date() }">
                                {{ moment(row.expiration_date).format('YYYY-MM-DD') }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quantity" label="在庫数" width="66" header-align="center" align="right">
                        <template #default="scope">
                            <span :class="{ 'text-red-500': scope.row.check_result6 === 2 }">
                                {{ scope.row.quantity }}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column label="通知" width="52" align="center">
                        <template #default="scope">
                            <span class="material-symbols-outlined cursor-pointer mt-2"
                                @click="openNotificationDialog(scope.row)">
                                mail
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="status" label="ステータス" width="100" align="center">
                        <template #default="scope">
                            <span v-if="scope.row.status === 1">未対応</span>
                            <span v-if="scope.row.status === 2">補充依頼中</span>
                            <span v-if="scope.row.status === 3">発注済み</span>
                            <span v-if="scope.row.status === 4">廃棄予定</span>
                            <span v-if="scope.row.status === 5">対応完了</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="check_result" label="アラート" width="80" align="center">
                        <template #default="{ row }">
                            <template v-for="alert in getAlert(row)" :key="alert">
                                <div>{{ alert }}</div>
                            </template>
                        </template>
                    </el-table-column>

                    <el-table-column prop="updated_date" label="更新日時" width="120" align="center">
                        <template #default="{ row }">
                            {{ moment(row.updated_date).format('YYYY-MM-DD HH:mm:ss') }}
                        </template>
                    </el-table-column>
                    <el-table-column label="削除" width="52" align="center">
                        <template #default="scope">
                            <span class="material-symbols-outlined cursor-pointer mt-2"
                                @click="handleDeleteButton(scope.row)">
                                delete
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页部 -->
            <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="mTotalRecords" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="mTotalRecords"
                        @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-mian>
    </el-container>

    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" style="max-width:800px"
        v-model="dialogFormVisible" title="詳細" align-center>
        <div class="flex-col w-full px-2 justify-center items-center">
            <!-- 右侧表单 -->
            <el-form :model="form" :rules="rules" ref="formRef" label-width="auto">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-1/2 md:px-2">
                        <el-form-item v-if="loginUserRole === ROLES.SYSTEM" label="組織" prop="organization_id"
                            label-width="100px">
                            <OrganizationSelect v-model="form.organization_id" :disabled="form.add_update === 'update'"
                                @organization-name-change="form.organization_name = $event" placeholder="組織を選択" />
                        </el-form-item>
                        <el-form-item
                            v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)"
                            label="部門" prop="department_id" label-width="100px">
                            <DepartmentSelect :organization-id="form.organization_id" v-model="form.department_id"
                                :disabled="form.add_update === 'update'"
                                @department-name-change="form.department_name = $event" placeholder="部門を選択" />
                        </el-form-item>
                        <el-form-item label="カテゴリ" prop="category_id" label-width="100px">
                            <CategorySelect :organization-id="form.organization_id" v-model="form.category_id"
                                :disabled="form.add_update === 'update'"
                                @category-name-change="form.category_name = $event" placeholder="カテゴリを選択" />
                        </el-form-item>
                        <el-form-item label="アイテム名" prop="material_code" label-width="100px">
                            <MaterialSelect :organization-id="form.organization_id" v-model="form.material_code"
                                :disabled="form.add_update === 'update'"
                                @material-name-change="form.material_name = $event" placeholder="アイテム名を選択" />
                        </el-form-item>
                        <el-form-item label="在庫数" prop="quantity" label-width="100px">
                            <el-input-number v-model="form.quantity" :min="0" :max="999999" />
                        </el-form-item>

                    </div>
                    <div class="w-full md:w-1/2 md:px-2">
                        <el-form-item label="保管日" prop="storage_date" label-width="100px">
                            <el-date-picker v-model="form.storage_date" type="date" placeholder="保管日を選択" />
                        </el-form-item>
                        <el-form-item label="有効期限" prop="expiration_date" label-width="100px">
                            <el-date-picker v-model="form.expiration_date" type="date" placeholder="有効期限を選択" />
                        </el-form-item>
                        <el-form-item label="保管場所" prop="location" label-width="100px">
                            <el-input v-model="form.location" autocomplete="off" placeholder="保管場所を入力" />
                        </el-form-item>
                        <el-form-item label="ステータス" prop="status" label-width="100px">
                            <el-select v-model="form.status" placeholder="ステータスを選択">
                                <el-option label="未対応" :value="1" />
                                <el-option label="補充依頼中" :value="2" />
                                <el-option label="発注済み" :value="3" />
                                <el-option label="廃棄予定" :value="4" />
                                <el-option label="対応完了" :value="5" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="コメント" prop="comment" label-width="100px">
                            <el-input v-model="form.comment" autocomplete="off" placeholder="コメントを入力" />
                        </el-form-item>

                    </div>
                </div>
            </el-form>

            <div class="flex w-full items-center justify-center">
                <el-upload action="#" list-type="picture-card" :auto-upload="false" :on-change="handleImageChange" multiple
                    :on-remove="handleRemove" :limit="3" :on-exceed="handleExceed" :file-list="fileList" accept=".jpg,.jpeg,.png,.webp,.gif">
                    <el-icon v-if="fileList.length < 3">
                        <Plus />
                    </el-icon>
                    <template #file="{ file }">
                        <div class="w-full">
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <el-icon><zoom-in /></el-icon>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                                    <el-icon>
                                        <Delete />
                                    </el-icon>
                                </span>
                            </span>
                        </div>
                    </template>
                </el-upload>
            </div>

        </div>
        <template #footer>
            <div class="dialog-footer flex items-center">
                <el-button v-if="form.add_update === 'update' && dialogFormShowDel" type="danger"
                    @click="handleDeleteButton2(form.inventory_id, form.sk)">
                    在庫削除
                </el-button>
                <div class="flex gap-2 ml-auto">
                    <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                    <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">
                        確認
                    </el-button>
                </div>
            </div>
        </template>
    </el-dialog>

    <!-- 画像预览 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" style="max-width:800px" v-model="dialogVisible"
        align-center>
        <div class="flex justify-center items-center">
            <img w-full :src="dialogImageUrl" alt="Preview Image" />
        </div>
    </el-dialog>

    <!-- 通知ダイアログ -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" style="max-width:800px"
        v-model="notificationDialogVisible" title="通知" align-center>
        <div class="flex-col w-full px-2">
            <el-form label-width="auto">
                <el-form-item label="送信先" label-width="100px">
                    <el-select v-model="notificationForm.sendTo" multiple filterable placeholder="送信先を選択"
                        style="width: 100%" :max-collapse-tags="5" collapse-tags-tooltip class="notification-select">
                        <el-option v-for="recipient in recipientCandidates" :key="recipient.value"
                            :label="recipient.label" :value="recipient.value">
                            <div class="flex flex-col">
                                <span>{{ recipient.label }}</span>
                                <span class="text-gray-400 text-sm">{{ recipient.email }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="メッセージ" label-width="100px">
                    <el-select v-model="notificationForm.message" placeholder="メッセージを選択" style="width: 100%">
                        <el-option v-for="item in predefinedMessages" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="カスタムメッセージ" label-width="100px">
                    <el-input v-model="notificationForm.customMessage" type="textarea" rows="4"
                        placeholder="カスタムメッセージを入力してください" />
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="notificationDialogVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleSendNotification">送信</el-button>
            </div>
        </template>
    </el-dialog>

    <el-drawer v-model="statusDrawer" direction="btt" size="225px" :with-header="false">
        <div class="felx flex-col h-full p-5">
            <div class="flex items-center justify-center h-[72px]">
                <el-select v-model="editStatusItem.status" placeholder="ステータスを選択" size="large">
                    <el-option label="未対応" :value="1" />
                    <el-option label="補充依頼中" :value="2" />
                    <el-option label="発注済み" :value="3" />
                    <el-option label="廃棄予定" :value="4" />
                    <el-option label="対応完了" :value="5" />
                </el-select>
            </div>

            <div class="action-buttons">
                <el-button @click="statusDrawer = false" class="cancel-btn">
                    キャンセル
                </el-button>
                <el-button @click="handleStatusConfirm" class="confirm-btn">
                    更新
                </el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script lang="ts">
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn, FormInstance, FormRules, UploadFile } from 'element-plus';
import { defineComponent, nextTick, onMounted, ref, Ref } from 'vue';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import CategorySelect from '@/components/common/CategorySelect.vue';
import UserSelect from '@/components/common/UserSelect.vue';
import DepartmentSelect from '@/components/common/DepartmentSelect.vue';
import MaterialSelect from '@/components/common/MaterialSelect.vue';
import AutoCompleteInput from '@/components/common/AutoCompleteInput.vue';
import axios, { AxiosResponse } from 'axios';
import { Bell, Delete, Search, Promotion, ZoomIn, Plus } from '@element-plus/icons-vue';
import { ErrorCode, ResponseData, ResponseStatus, UploadImageResponseData } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { Operation, SearchRequest } from '@/components/common/request';
import router from '@/router';
import { ALL, IMG_MAX_SIZE, ROLES, ROUTES } from '@/config/constants';
import moment from 'moment';

interface checkResultInfo {
    id: string,
    organization_id: string,
    organization_name: string,
    department_id: string,
    department_name: string,
    user_id: string,
    user_name: string,
    material_code: string,
    material_name: string,
    category_id: string,
    category_name: string,
    inventory_id: string,
    sk: string,
    status: number,
    location: string,
    quantity: number,
    is_received: number,
    created_date: string,
    expiration_date: string,
    storage_date: string,
    images: string,
    comment: string,
    check_result1: number,
    check_result2: number,
    check_result3: number,
    check_result4: number,
    check_result5: number,
    check_result6: number,
}

interface InventoryInfo {
    add_update?: Operation;
    inventory_id: string;
    sk: string;
    material_code: string;
    organization_id: string;
    department_id: string;
    category_id: string;
    category_name: string;
    quantity: number;
    storage_date?: string;
    expiration_date: string;
    location?: string;
    images?: string;
    responsible_person?: string,
    organization_name?: string,
    department_name?: string,
    material_name?: string,
    comment?: string,
    fileList?: UploadFile[],
    status?: number,
}

export default defineComponent({
    name: 'MngCheckResult',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        OrganizationSelect,
        CategorySelect,
        DepartmentSelect,
        UserSelect,
        MaterialSelect,
        AutoCompleteInput,
        Bell,
        Plus,
        ZoomIn,
        Delete,
        Search,
        Promotion,
    },
    setup() {
        const searchForm = ref<any>({
            organization_id: ALL,
            department_id: ALL,
            status: ALL,
            category_id: ALL,
            material_name: '',
        });

        const form = ref<InventoryInfo>({
            add_update: Operation.unknow,
            inventory_id: '',
            sk: '',
            material_code: '',
            material_name: '',
            organization_id: '',
            organization_name: '',
            category_id: '',
            category_name: '',
            location: '',
            quantity: 0,
            storage_date: '',
            expiration_date: '',
            images: '',
            department_id: '',
            department_name: '',
            comment: '',
            status: 1,
        });

        const drawer = ref(false);
        const statusDrawer = ref(false);
        const editStatusItem = ref<checkResultInfo>({ status: 1 } as checkResultInfo);

        const checkResult = ref<number[]>([1, 2, 3, 4, 5, 6]); // 初期値を設定
        const checkResults = ref([
            { color: '#E63415', label: '1日以内', value: 1 },
            { color: '#FF6600', label: '1日前', value: 2 },
            { color: '#FFDE0A', label: '7日前', value: 3 },
            { color: '#1EC79D', label: '15日前', value: 4 },
            { color: '#14CCCC', label: '30日前', value: 5 },
            { color: '#4167F0', label: '在庫数', value: 6 },
        ]);

        //画像
        const dialogImageUrl = ref<string>('')
        const dialogVisible = ref<boolean>(false);

        const loading = ref<boolean>(true);
        const mTableData = ref<checkResultInfo[]>([]);
        const mCurrentPage = ref<number>(1);
        const mPageSize = ref<number>(10);
        const mTotalRecords = ref<number>(0);
        const size = ref<string>('small');
        const disabled = ref<boolean>(false);
        const background = ref<boolean>(true);

        const dialogFormVisible = ref(false);
        const dialogFormShowDel = ref<boolean>(false);
        const notificationDialogVisible = ref(false);
        const notificationForm = ref({
            sendTo: [] as string[],
            inventory_id: '',
            sk: '',
            message: '',
            customMessage: ''
        });

        const predefinedMessages = ref([
            { label: '期限が近くなっています。', value: '期限が近くなっています。' },
            { label: '廃棄をお願いします。', value: '廃棄をお願いします。' },
            { label: '廃棄許可をお願いします。', value: '廃棄許可をお願いします。' },
            { label: '期限の更新をお願いします。', value: '期限の更新をお願いします。' },
            { label: '期限を確認してください。', value: '期限を確認してください。' }
        ]) as Ref<Array<{ label: string; value: string }>>;

        const formRef = ref<FormInstance>();
        const rules = ref<FormRules>({
            organization_id: [
                { required: true, message: '組織を選択してください', trigger: 'change' }
            ],
            department_id: [
                { required: true, message: '部門を選択してください', trigger: 'change' }
            ],
            material_code: [
                { required: true, message: 'コードを選択してください', trigger: 'change' }
            ],
            category_id: [
                { required: true, message: 'カテゴリを選択してください', trigger: 'change' }
            ],
            quantity: [
                { required: true, message: '在庫数を入力してください', trigger: 'blur' },
                { type: 'number', min: 0, message: '在庫数は0以上の数字を入力してください', trigger: 'blur' }
            ],
            storage_date: [
                { required: true, message: '保管日を選択してください', trigger: 'change' }
            ],
            expiration_date: [
                { required: true, message: '失効日を選択してください', trigger: 'change' }
            ]
        });

        // 画像预览
        const imageUrl = ref<string>('')

        const fileList = ref<UploadFile[]>([])

        const loginUserRole = localStorage.getItem('role');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';

        const materialNameInput = ref<any>(null);

        const recipientCandidates = ref([
            { value: 'user1', label: 'John Smith', email: 'john.smith@example.com' },
            { value: 'user2', label: 'Jane Doe', email: 'jane.doe@example.com' },
            { value: 'user3', label: 'EXPODEMO', email: 'expo@demo.com' }
        ]) as Ref<Array<{ value: string; label: string; email: string }>>;

        /***** マウント **************************/
        onMounted(() => {
            //  如果没有信息，重新登陆
            if (!loginUserRole) {
                router.push(`/${ROUTES.LOGIN}`);
            }
            getCheckResultList();
            getRecipients();
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            drawer.value = false;

            if (materialNameInput.value) {
                materialNameInput.value.submitValue();
            }
            getCheckResultList();
        };

        const handleSizeChange = (size: number) => {
            mPageSize.value = size;
            getCheckResultList();
        };
        const handleCurrentChange = (page: number) => {
            mCurrentPage.value = page;
            getCheckResultList();
        };

        const handleDeleteButton = (row: checkResultInfo) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteCheckResultInfo(row);
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleDeleteButton2 = (inventory_id: string, sk: string) => {
            const row = {
                inventory_id,
                sk,
            };
            handleDeleteButton(row as checkResultInfo);
        };

        const deleteCheckResultInfo = async (row: checkResultInfo) => {
            dialogFormVisible.value = false;
            try {
                loading.value = true;
                const res: AxiosResponse<ResponseData> = await axios.delete(`/api/inventories2/${row.inventory_id}`, {
                    data: {
                        sk: row.sk
                    }
                });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    await getCheckResultList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.INVENTORY, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.INVENTORY));
            } finally {
                loading.value = false;
            }
        };

        const handleEditButton = (row: checkResultInfo, dialogShowDel?: boolean) => {
            dialogFormVisible.value = true;
            dialogFormShowDel.value = dialogShowDel || false;
            nextTick(async () => {
                formRef.value?.resetFields();
                fileList.value = []

                let inventoryInfo: InventoryInfo | undefined = undefined;
                try {
                    const res: AxiosResponse<ResponseData<InventoryInfo>> = await axios.get(`/api/inventories2/${row.inventory_id}`, {
                        params: {
                            sk: row.sk
                        }
                    });

                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        const { data } = res.data;

                        inventoryInfo = data;
                    } else {
                        ElMessage.error(getErrorMessage(PageType.INVENTORY, res.data.code));
                    }

                } catch (error) {
                    ElMessage.error(getErrorMessage(PageType.INVENTORY));
                } finally {
                    form.value = {
                        add_update: Operation.update,
                        inventory_id: row.inventory_id,
                        sk: row.sk,
                        material_code: inventoryInfo?.material_code || row.material_code,
                        organization_id: inventoryInfo?.organization_id || row.organization_id,
                        department_id: inventoryInfo?.department_id || row.department_id,
                        category_id: inventoryInfo?.category_id || row.category_id,
                        location: inventoryInfo?.location || row.location,
                        quantity: inventoryInfo?.quantity || row.quantity,
                        storage_date: inventoryInfo?.storage_date || row.storage_date,
                        expiration_date: inventoryInfo?.expiration_date || row.expiration_date,
                        images: inventoryInfo?.images || row.images,
                        department_name: inventoryInfo?.department_name || row.department_name,
                        organization_name: inventoryInfo?.organization_name || row.organization_name,
                        material_name: inventoryInfo?.material_name || row.material_name,
                        category_name: inventoryInfo?.category_name || row.category_name,
                        comment: inventoryInfo?.comment || row.comment,
                        status: inventoryInfo?.status || row.status,
                    };
                    if (form.value.images) {
                        let bufImages = form.value.images.split(',');
                        fileList.value = await getImages(bufImages);
                    } else {
                        fileList.value = []
                    }
                }
            });
        };

        const getImages = async (image_ids: string[]) => {
            var fileLst: UploadFile[] = [];

            for (const image_id of image_ids) {
                const res = await axios.get(`/api/images/download/${image_id}`, { responseType: 'blob' });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                    const uid = parseInt(image_id);
                    fileLst.push({
                        url: URL.createObjectURL(res.data),
                        uid: uid,
                        name: image_id,
                        raw: res.data,
                        status: 'ready'
                    });
                } else {
                    ElMessage.error('画像情報の取得に失敗しました。');
                }
            }

            return fileLst;
        };

        const getRecipients = async () => {
            try {
                const res: AxiosResponse<ResponseData<any[]>> = await axios.get('/api/users/organization');
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    if (res.data.data) {
                        recipientCandidates.value = res.data.data.map(user => ({
                            value: user.user_id,
                            label: user.username,
                            email: user.email
                        }));
                    }
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.INVENTORY));
            }

        }

        const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    updateInventory(form.value);
                    dialogFormVisible.value = false;
                }
            })
        };

        const handleSendNotification = async () => {
            try {
                const res: AxiosResponse<ResponseData<any>> = await axios.post('/api/alarm-messages/send', notificationForm.value);
                console.log(res.data.data);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {

                    ElMessage.success('アラートメッセージを送信しました');
                    // getCheckResultList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.INVENTORY, res.data.code));
                }
            } catch (error) {
                console.log(error);
                ElMessage.error(getErrorMessage(PageType.INVENTORY));
            } finally {
                notificationDialogVisible.value = false;
            }
        }

        const updateInventory = async (row: InventoryInfo) => {
            try {
                loading.value = true;

                //画像アップロード
                let images = [];
                const rowImages = row.images?.split(',') || [];

                fileList.value.map(file => file.name).forEach(fileName => {
                    if(rowImages.includes(fileName)) {
                        images.push(fileName);
                    }
                });

                // 新的图片列表中不包含rowImages中的图片，这些是需要上传的
                const newfileList = fileList.value.filter(file => !rowImages.includes(file.name));

                if (newfileList.length > 0) {
                    const imgaeInfos = await uploadImages(newfileList);
                    if (imgaeInfos) {
                        for (const imgaeInfo of imgaeInfos) {
                            images.push(imgaeInfo.id);
                        }
                    } else {
                        ElMessage.error('画像アップロード失敗しました。');
                        return;
                    }
                }
                
                form.value.images = images.join(',');

                const res: AxiosResponse<ResponseData<InventoryInfo>> = await axios.put(`/api/inventories2/${row.inventory_id}`, row);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getCheckResultList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.INVENTORY, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.INVENTORY));
            } finally {
                loading.value = false;
            }
        };




        /***** DB 操作 **************************/
        const getCheckResultList = async () => {
            loading.value = true;
            try {
                const params: SearchRequest = {
                    page: mCurrentPage.value,
                    limit: mPageSize.value,

                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    department_id: searchForm.value.department_id === ALL ? '' : searchForm.value.department_id,
                    status: searchForm.value.status === ALL ? '' : searchForm.value.status,
                    category_id: searchForm.value.category_id === ALL ? '' : searchForm.value.category_id,
                    material_name: searchForm.value.material_name,
                    check_result: checkResult.value,
                };

                const res: AxiosResponse<ResponseData<checkResultInfo[]>> = await axios.get('/api/check-results/search', { params });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    console.log(res.data);
                    const { total, totalPages, currentPage, data } = res.data;
                    mTotalRecords.value = total || 0;
                    mTableData.value = data || [];
                } else {
                    ElMessage.error(getErrorMessage(PageType.ALERT, res.data.code));
                }

            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.ALERT));
            } finally {
                loading.value = false;
            }
        };


        const uploadImages = async (fileList: UploadFile[]) => {
            if (fileList.length > 0) {
                const formData = new FormData()
                // 统计所有文件的总大小
                let totalSize = 0;
                for (const tFile of fileList) {
                    if (tFile.raw) {
                        totalSize += tFile.raw.size;
                    }
                }
                
                // 检查总大小是否超过限制
                if (totalSize > IMG_MAX_SIZE) {
                    ElMessage.error('ファイルが大きすぎます。');
                    return '';
                }
                
                for (const tFile of fileList) {
                    formData.append('files', tFile.raw || new Blob())
                    //文件过大 100K
                    if (tFile.raw && tFile.raw.size > IMG_MAX_SIZE) {
                        ElMessage.error('ファイルが大きすぎます。');
                        return '';
                    }
                }

                try {
                    const res: AxiosResponse<UploadImageResponseData> = await axios.post('/api/images/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        ElMessage.success('画像アップロード成功');
                        return res.data.images; // 返回值
                    } else {
                        ElMessage.error('画像アップロード失敗');
                        return '';
                    }
                } catch (error) {
                    ElMessage.error('画像アップロード失敗')
                    return ''; // 返回值
                }
            } else {
                ElMessage.error('ファイルが無効です')
                return ''; // 返回值
            }
        }

        // 画像変更
        const handleImageChange = (file: UploadFile) => {
            if (fileList.value.length >= 4) {
                ElMessage.warning('最大3枚までアップロードできます片。')
                return false
            }
            fileList.value.push(file)
            imageUrl.value = URL.createObjectURL(file.raw || new Blob())
        }

        // 画像削除
        const handleRemove = (file: UploadFile) => {
            // 触发画面重绘
            const index = fileList.value.findIndex(item => item.name === file.name);
            if (index !== -1) {
                fileList.value.splice(index, 1);
                // 触发视图更新
                fileList.value = [...fileList.value];
            }
        }

        // 画像预览
        const handlePictureCardPreview = (file: UploadFile) => {
            dialogImageUrl.value = file.url || ''
            dialogVisible.value = true
        }

        const handleExceed = (files: File[]) => {
            //ElMessage.warning(`最多只能上传4张图片。当前选择了 ${files.length} 张图片，已有 ${fileList.value.length} 张图片。`)
            ElMessage.warning('最大3枚までアップロードできます。')
        }



        const tableRowClassName = ({ row, rowIndex }: { row: checkResultInfo, rowIndex: number }) => {
            if (new Date(row.expiration_date) < new Date()) {
                return 'warning-row'
            } else {
                return ''
            }
        }

        const handleStatusConfirm = async () => {
            statusDrawer.value = false;
            if (!editStatusItem.value) return;

            try {
                loading.value = true;

                const res: AxiosResponse<ResponseData<InventoryInfo>> = await axios.put(`/api/inventories2/${editStatusItem.value.inventory_id}`, {
                    sk: editStatusItem.value.sk,
                    status: editStatusItem.value.status,
                });

                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    await getCheckResultList();
                    ElMessage.success('ステータスが更新されました');
                } else {
                    ElMessage.error(getErrorMessage(PageType.INVENTORY, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.INVENTORY));
            } finally {
                loading.value = false;
                editStatusItem.value = { status: 1 } as checkResultInfo;
            }
        };

        const editStatus = (item: checkResultInfo) => {
            editStatusItem.value = { ...item };
            statusDrawer.value = true;
        };

        const openNotificationDialog = (row: checkResultInfo) => {
            notificationDialogVisible.value = true;
            notificationForm.value = {
                sendTo: [],
                inventory_id: row.inventory_id,
                sk: row.sk,
                message: '',
                customMessage: ''
            };
        };

        const getAlert = (row: checkResultInfo) => {
            const result = [];
            
            const v = 2;
            if(row.check_result1 === v){
                result.push('1日以内');
            }else if(row.check_result2 === v){
                result.push('1日前');
            }else if(row.check_result3 === v){
                result.push('7日前');
            }else if(row.check_result4 === v){
                result.push('15日前');
            }else if(row.check_result5 === v){
                result.push('30日前');
            }
            
            if(row.check_result6 === v){
                result.push('在庫数');
            }

            return result;
        };

        return {
            loginUserRole,
            loginUserRoleIsHead,
            searchForm,
            mTableData,
            loading,
            mCurrentPage,
            mPageSize,
            mTotalRecords,
            size,
            disabled,
            background,
            form,
            dialogFormVisible,
            dialogFormShowDel,
            notificationDialogVisible,
            notificationForm,
            predefinedMessages,
            openNotificationDialog,
            handleAddUpdateSubmit,
            formRef,
            rules,
            imageUrl,
            handleSearchButton,
            handleSizeChange,
            handleCurrentChange,
            handleImageChange,
            handleEditButton,
            handleRemove,
            handlePictureCardPreview,
            fileList,
            handleExceed,
            dialogImageUrl,
            dialogVisible,
            ROLES,
            ALL,
            tableRowClassName,
            materialNameInput,
            drawer,
            statusDrawer,
            checkResult,
            checkResults,
            handleDeleteButton,
            handleStatusConfirm,
            handleDeleteButton2,
            editStatus,
            editStatusItem,
            recipientCandidates,
            handleSendNotification,
            moment,
            getAlert,
        }
    }
});
</script>

<style>
.el-table .warning-row {
    --el-table-tr-bg-color: #f3f3c1;
}

.el-tag {
    border: none;
    aspect-ratio: 1;
}

.action-buttons {
    display: flex;
    gap: 20px;
    margin-top: 40px;
}

.action-buttons .el-button {
    flex: 1;
    height: 50px;
    font-size: 28px;
}

.cancel-btn {
    color: #f56e6e;
    border: none;
}

.confirm-btn {
    color: #215e99;
    border: none;
}

.notification-select :deep(.el-select__tags) {
    max-height: 72px;
    overflow-y: auto;
}

.notification-select :deep(.el-select__wrapper) {
    min-height: 80px;
    height: auto;
    padding: 4px 8px;
}
</style>